import { createRouter, createWebHistory } from 'vue-router'
import { supabase } from '../lib/supabase'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import ProductView from '../views/ProductsView.vue'
import ContactView from '../views/ContactView.vue'
import BlogView from '../views/BlogView.vue'
import BlogPostView from '../views/BlogPostView.vue'
import LoginView from '../views/LoginView.vue'
import EbookView from '../views/EbookView.vue'

// Definición de rutas
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
  },
  {
    path: '/products',
    name: 'products',
    component: ProductView,
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
  },
  {
    path: '/blog',
    name: 'blog',
    component: BlogView,
  },
  {
    path: '/blog/:slug',
    name: 'blog-post',
    component: BlogPostView,
  },
  {
    path: '/ebook',
    name: 'ebook',
    component: EbookView,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/editor/:id',
    name: 'admin-editor-edit',
    component: () => import('../views/EditorView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/editor',
    name: 'admin-editor-new',
    component: () => import('../views/EditorView.vue'),
    meta: { requiresAuth: true },
  },
]

// Configuración del router
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si hay un hash en la URL, navegar a ese elemento
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 0,
      }
    }

    // Si hay una posición guardada (navegación hacia atrás/adelante)
    if (savedPosition) {
      return savedPosition
    }

    // Para navegación normal, ir al inicio de la página
    return {
      top: 0,
      behavior: 'smooth',
    }
  },
})

// Guard de navegación para proteger rutas de administración
router.beforeEach(async (to, from, next) => {
  // Verificar si la ruta requiere autenticación
  if (to.meta.requiresAuth) {
    try {
      // Obtener la sesión actual
      const { data: { session } } = await supabase.auth.getSession()

      if (session && session.user) {
        // Usuario autenticado, permitir acceso
        next()
      } else {
        // Usuario no autenticado, redirigir al login
        console.log('Acceso denegado: Usuario no autenticado')
        next({ path: '/login', query: { from: 'admin' } })
      }
    } catch (error) {
      console.error('Error al verificar autenticación:', error)
      // En caso de error, redirigir al login por seguridad
      next({ path: '/login', query: { from: 'admin' } })
    }
  } else {
    // Ruta no requiere autenticación, permitir acceso
    next()
  }
})

export default router
